import { createStore } from 'vuex'

export default createStore({
    state: {
        indexProductList: {},
        token: '',
        commonContent: {},
        platform: '',
        websiteData: {}
    },
    getters: {
        indexProductList: state => state.indexProductList,
        token: state => state.token,
        commonContent: state => state.commonContent,
        platform: state => state.platform,
        websiteData: state => state.websiteData
    },
    mutations: {
        setIndexProductList(state, type) {
            state.indexProductList = type
        },
        setToken(state, type) {
            state.token = type
        },
        setCommonContent(state, type) {
            state.commonContent = type
        },
        setPlatform(state, type) {
            state.platform = type
        },
        setWebsiteData(state, type) {
            state.websiteData = type
        }
    },
    actions: {

    },
    modules: {
    }
})